<!-- form #userForm="ngForm" (ngSubmit)="onSend(userForm)" -->
<div mat-dialog-content>
  <p>{{good.name}}

    <button style="float: right;" mat-icon-button (click)="manual()"
      [style]="!manualEdit ? 'display: inline; border:0':'display: none;'">
      <mat-icon>edit</mat-icon>
    </button>
  </p>
  <small style="color: gray;">[{{good.codeExch}}] {{good.country}}/{{good.contract}}</small>
  <p>
    <small style="color: gray;">{{good.goodType}}/{{good.goodCategory}}</small>

  </p>
  <!--pre>
    {{good | json}}
    </pre -->
  <p *ngIf="good.stateId" [ngStyle]="{'background-color':good.stateColor}">
    <small>{{good.stateName}}</small>
  </p>
  <p>
    <small>min {{good.minPart}} квант {{good.quantum}}</small>
  <p>
    Цена:
    <span class="currency">{{price | currency :'RUB':'symbol':'1.2-2':'ru'}}
    </span>
  </p>


  <p>
    <span> <!--*ngIf="quantity && quantity>0"-->
      Сумма:
      <span class="currency">
        {{quantity * price | currency :'RUB':'symbol':'1.2-2':'ru'}}
      </span>
    </span>

  </p>



  <div style="text-align: center;">


    <mat-button-toggle checked="false" class="but_add minus" mat-icon-button (click)="add(-1)"><mat-icon
        class="icon_mid">remove</mat-icon></mat-button-toggle>

    <mat-form-field class="quantity_input" style="line-height: 23.6px;" appearance="outline">
      <mat-label>Кол-во</mat-label>
      <input matInput #quantityInput type="number" name="quantity" (keyup)="quantityChange($event)"
        [value]="quantity ? quantity : ''" (keyup.enter)="onSend()">

    </mat-form-field>

    <mat-button-toggle checked="false" class="but_add plus" (click)="add(+1)"><mat-icon
        class="icon_mid">add</mat-icon></mat-button-toggle>


  </div>



  <div [style]="manualEdit ? 'display: block;':'display: none;'">
    <mat-form-field class="sto" appearance="outline">
      <mat-label>Код акции</mat-label>
      <input matInput type=" text" [(ngModel)]="promotionCode">
    </mat-form-field>
  </div>




  <div>

    <div style="text-align: center; height: 36px;">
      <span class="sto" *ngIf="well(); else badBranch" class='goodRatio'>{{goodRatioLabel()}}</span>

      <ng-template #badBranch>
        <span>
          <button class="sto" color="warn" mat-flat-button (click)="addBox(true)">{{badRatioLabel()}} </button>
        </span>
      </ng-template>

    </div>

    <div *ngIf="good.minPart > 1 || good.ratioPackage > 1">
      <span class="csto" style="display: inline-block;">

        <span class="air-span " *ngIf="good.minPart  && good.minPart > 1 && good.minPart !== good.ratioPackage">
          <button class="air-button110-l sto" mat-flat-button color="warn" (click)="add(-good.minPart)"
            [disabled]="!quantity || quantity<good.minPart">
            -{{good.minPart}}</button>
        </span>

        <span class="air-span " *ngIf="hasBlock">
          <button class="air-button110-l sto" mat-flat-button color="warn" (click)="removeBlock()"
            [disabled]="!quantity || quantity<this.blockRatio">
            -{{this.blockRatio}}</button>
        </span>

        <span class="air-span " *ngIf="good.ratioPackage>1">
          <button class="air-button110-l sto" mat-flat-button color="warn" (click)="removeBox()"
            [disabled]="!quantity || quantity<good.ratioPackage">
            -{{good.ratioPackage}}</button>
        </span>




      </span>


      <span class="csto" style="display: inline-block;">


        <span class="air-span " *ngIf="good.minPart  && good.minPart>1 && good.minPart !== good.ratioPackage">
          <button class="air-button110-r sto" mat-flat-button color="primary" (click)="add(good.minPart)">
            +{{good.minPart}}</button>
        </span>

        <span class="air-span " *ngIf="hasBlock">
          <button class="air-button110-r sto" mat-flat-button color="primary" (click)="addBlock()">
            +{{this.blockRatio}}</button>
        </span>

        <span class="air-span " *ngIf="good.ratioPackage>1">
          <button class="air-button110-r sto" mat-flat-button color="primary" (click)="addBox()">
            +{{good.ratioPackage}}</button>
        </span>




      </span>

    </div>

  </div>

  <div style="height: 36px;">
    <span *ngIf="quantity && quantity>0 && quantity<good.minPart && !ignoreMinPart">
      <button class="sto" mat-raised-button color="accent" (click)="add(good.minPart-quantity)">
        минимальная партия:
        {{good.minPart}} </button>
    </span>
  </div>

</div>

<div mat-dialog-actions>
  <button mat-flat-button color="accent" class="air-button110-r" [mat-dialog-close]="">Отмена</button>
  <button mat-flat-button color="primary" class="air-button110-r" (click)="onSend()"
    [disabled]="(!quantity || quantity  < good.minPart) && !ignoreMinPart">Добавить</button>
  <button mat-icon-button color="accent" [disabled]="!data.canDeleteItem" (click)="deleteItem()">
    <mat-icon>delete</mat-icon>
  </button>

</div>